export default class BlMode {
  constructor(serialNumber, code, name, localName) {
    this.serialNumber = serialNumber
    this.code = code
    this.name = name
    this.localName = localName
  }
}

export const ORIGINAL_BL_MODE = new BlMode(1, 'ORIGINAL', 'ORIGINAL', 'SeaExport.OriginalNormal')
export const SURRENDERED_BL_MODE = new BlMode(2, 'SURRENDERED', 'SURRENDERED', 'SeaExport.TelexRelease')
export const SEA_WAYBILL_BL_MODE = new BlMode(3, 'SEA WAYBILL', 'SEA WAYBILL', 'SeaExport.TelexRelease')

export const BL_MODES = [
  ORIGINAL_BL_MODE,
  SURRENDERED_BL_MODE,
  SEA_WAYBILL_BL_MODE
]
